export enum headerTypeTitle {
  'сертификата',
  'депозита',
  'услуги'
}